import { FC } from "react";

import { formatAuctionIdleSummary, getIdleThumbnailUrl } from "./helpers";
import { ThumbnailedSummaryLayout } from "./ThumbnailedSummaryLayout";

import { useCurrentUserContext } from "@/common/contexts/CurrentUserContext";
import { useLocaleContext } from "@/common/contexts/LocaleContext";
import { useTranslate } from "@/common/hooks/useTranslate";
import { RateData } from "@/features/LiveFormEditor/Steps/StepTickets/Rates/types";

interface AuctionIdleSummaryProps {
  title: string;
  rate: Partial<RateData>;
  isExpanded: boolean;
}

export const AuctionIdleSummary: FC<AuctionIdleSummaryProps> = ({ title, rate, isExpanded }) => {
  const { t } = useTranslate();
  const { locale } = useLocaleContext();
  const { organizationCurrency } = useCurrentUserContext();

  const thumbnailUrl = getIdleThumbnailUrl(rate);
  const subtitle = formatAuctionIdleSummary(rate, { locale, currency: organizationCurrency, t });

  return (
    <ThumbnailedSummaryLayout title={title} thumbnailUrl={thumbnailUrl} subtitle={subtitle} isExpanded={isExpanded} />
  );
};
